import React from 'react'
import PropTypes from 'prop-types'
import { auth, database, storage } from 'helpers/firebase'

import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Grow from 'material-ui/transitions/Grow'
import Snackbar from 'material-ui/Snackbar'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import Close from '@material-ui/icons/Close'

import EditDialog from 'components/EditDialog'
import ParticleBackground from 'components/ParticleBackground'

import { APP_TITLE } from 'constants/customization'
import { pinUnlockSchema, registrationSchema } from 'constants/schemas'
import styles from 'styles/screens/Registration'

class Registration extends React.Component {
  state = {
    pinCheck: false,
    pinFail: false,
    welcome: false
  }

  handlePinCheck = () => {
    this.setState({ pinCheck: true })
  }

  handleCancelPinCheck = () => {
    this.setState({ pinCheck: false })
  }

  handleClosePinFail = () => {
    this.setState({ pinFail: false })
  }

  handleUnlock = ({ pin }) => {
    if (String(this.props.userState.pin) === String(pin)) {
      const updates = {
        [`/users/${auth.currentUser.uid}/registrationMode`]: ''
      }
      database.ref().update(updates)
    } else {
      this.setState({ pinCheck: false, pinFail: true })
    }
  }

  handleChange = key => event => {
    this.setState({
      [key]: event.target.value,
      [key + 'Invalid']: false
    })
  }

  handleRegistration = attendee => {
    const attendeeRef = database
      .ref(`courses/${this.props.userState.registrationMode}`)
      .child('attendees')
      .push()

    storage
      .ref()
      .child(
        `signatures/${this.props.userState.registrationMode}/${
          attendeeRef.key
        }.png`
      )
      .putString(attendee.signature.split(',')[1], 'base64')
      .then(snapshot => {
        attendeeRef.set({
          ...attendee,
          signature: snapshot.downloadURL
        })
      })

    this.setState(
      {
        welcome: attendee.firstName,
        welcomeTransition: true
      },
      () => {
        this.timeout = setTimeout(() => {
          this.setState(
            {
              welcomeTransition: false
            },
            () => {
              this.timeout = setTimeout(() => {
                this.setState({ welcome: false })
              }, 500)
            }
          )
        }, 3500)
      }
    )
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  render() {
    const { classes, userState, courses } = this.props
    const { pinCheck, pinFail, welcome, welcomeTransition } = this.state

    const course = courses[userState.registrationMode]

    return (
      <ParticleBackground>
        <div className={classes.wrapper}>
          <div className={classes.appTitleWrapper}>
            <Typography
              variant="headline"
              className={classes.appTitle}
              onClick={this.handlePinCheck}
            >
              {APP_TITLE}
            </Typography>
          </div>
          {pinCheck && (
            <EditDialog
              cancel={this.handleCancelPinCheck}
              fields={pinUnlockSchema}
              open
              title="Exit Registration Mode"
              submitLabel="Unlock"
              update={this.handleUnlock}
            />
          )}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            open={pinFail}
            autoHideDuration={5000}
            onClose={this.handleClosePinFail}
            message={<span id="incorrect-pin">Incorrect PIN</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleClosePinFail}
              >
                <Close />
              </IconButton>
            ]}
          />
          <div
            style={{
              display: pinCheck && 'none',
              textAlign: 'center'
            }}
          >
            {welcome ? (
              <Grow in={welcomeTransition}>
                <div>
                  <Icon className={classes.welcomeIcon}>done</Icon>
                  <Typography variant="headline" className={classes.welcome}>
                    Welcome {welcome}!
                  </Typography>
                </div>
              </Grow>
            ) : (
              <Grow in={!welcome}>
                <div>
                  <Typography variant="headline" className={classes.welcome}>
                    Welcome to {course.title || 'Course Title'}!
                  </Typography>
                  <EditDialog
                    card
                    current={{
                      company: course.company || ''
                    }}
                    fields={registrationSchema}
                    title="Sign In"
                    submitLabel="Sign In"
                    update={this.handleRegistration}
                  />
                </div>
              </Grow>
            )}
          </div>
        </div>
      </ParticleBackground>
    )
  }
}

Registration.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Registration)



// WEBPACK FOOTER //
// ./src/views/Registration.jsx